import { ErrorMessage, Field } from "formik"
import classNames from "classnames";
import "./FormFieldInput.css";
import PhoneInput from "react-phone-number-input";
import { useEffect } from "react";

import 'react-phone-number-input/style.css';
import moment from "moment";


interface CustomProps {
  field?: any,
  form?: any,
  meta?: any
}

interface Props {
  name: string;
  label?: string | undefined;
  required?: boolean;
  values?: Array<any>;
  placeholder?: string;
  value?: any;
  min?: number;
  max?: number;
  setFieldValue?: any;
  disable?: boolean;
  accept?: string;
  errors?: any;
  onChange?: any;
  type?: "text" | "number" | "color" | "date" | "datetime-local" | "month" | "password" | "search" | "time" | "file" | "email" | "phone"
}

const FormFieldInput = ({
  name,
  label,
  required,
  placeholder,
  value,
  min = 0,
  max = 0,
  setFieldValue,
  disable=false,
  accept,
  errors,
  onChange,
  type = "text"} : Props) => {
  
  useEffect(() => {
    if(setFieldValue && value) {
      setFieldValue(name, value);
    }
  }, []);

  useEffect(() => {
    if(type == "phone") {
      let matchers = document.getElementById(name);
      if(matchers != null) {
        matchers.classList.add("form-control");
      }

      let countrys = document.getElementsByClassName("PhoneInputCountry");
      for (let i = 0; i < countrys.length; i++) {
        // matchers[i].classList.remove("colorbox");
        let result = countrys.item(i);
        if(result != null) {
          result.setAttribute("style", "display: none;");
        }
      }
    }
  }, [type]);
  
  return (
    <div className="d-block w-100 form-field col-12 mt-0 p-0">
      {label && <label className="form-label mb-2 w-100" htmlFor={name} >{label} {required && <span className=" text-danger">*</span>}</label>}
      
      <div className={classNames("w-100")}>
        { type === "file" &&
              <Field  
                placeholder={placeholder} 
                name={name} 
                id={name} 
                className={classNames("form-control")}
                value={value}
                type={type}
                setFieldValue={setFieldValue}
                onChange={onChange}
                accept={accept}
                errors={errors}
                
              />
        }
         { type !== "file" && type !== "number" && type !== "phone" &&
              <Field  
                placeholder={placeholder} 
                name={name} 
                id={name} 
                value={type === "date" ? moment(value).format("yyyy-MM-DD"): value}
                type={type}
                setFieldValue={setFieldValue}
                accept={accept}
                errors={errors}
                children={({ field, form, meta }: CustomProps) => (
                  <input {...field} id={name} disabled={disable} onChange={(e)=> setFieldValue(name, e.target.value)} value={type === "date" ? moment(value).format("yyyy-MM-DD"): value} className={classNames("form-control")} name={name} type={type} placeholder={placeholder} />
                )}
              />
        }
         { type == "number" &&
              <Field  
                placeholder={placeholder} 
                name={name} 
                id={name} 
                className={classNames("form-control")}
                //min={min}
                //max={max}
                value={value}
                type={type}
                setFieldValue={setFieldValue}
                accept={accept}
                errors={errors}
              />
        }
         { type == "phone" &&
              <PhoneInput
                placeholder={placeholder} 
                name={name} 
                id={name} 
                style={{ width: "100%" }}
                value={value}
                defaultCountry="CM"
                onChange={(e) => setFieldValue(name, e) }
            />
        }
        <div className="span field-error"> 
          <ErrorMessage name={name}/>
        </div>
      </div>
    </div>
  )
}

export default FormFieldInput;